import React, {forwardRef}  from 'react';
import CalculationItem from "../../../Atoms/Items/CalculationItem";
import CalculationModal from "../CalculationModal";
import Icon from "../../../Atoms/Icon";

const DaytimeHoursModal = forwardRef((props, ref) => {
  return (
    <CalculationModal ref={ref}>
      <h3>Cálculo de horas extras diurnas</h3>
      <div>
        <CalculationItem
          amount="3,000,000"
          text="sueldo"
        />
        <hr/>
        <div className="calculations">
          <CalculationItem
            amount="240,000"
            text="horas"
            isColumn
          />
          <Icon svg="cross" />
          <CalculationItem
            amount="2.4"
            text="novedad"
            isColumn
          />
          <Icon svg="plus" />
          <CalculationItem
            amount="1.25"
            text="valor"
            isColumn
          />
        </div>
      </div>
    </CalculationModal>
  );
})

export default DaytimeHoursModal;
